import React from "react";
import PetAdoptedChart from "./component/PetChart/PetChart";
import TopField from "../ProgramDashboard/component/TopField/TopField.view";
import useUserDashboard from "./UserDashboard.hook";
import styles from "./Style.module.css";
import StackedBarChart from "../ProgramDashboard/component/StackedBarChart/StackedBarChart.view";
import EarnerTable from "./component/EarnerTable/EarnerTable.view";
import EngagementTable from "./component/EngagementTable/EngagementTable.view";
import TrendChart from "../ProgramDashboard/component/TrendChart/TrendChart";
import CustomRadarChart from "./component/RadarChart/RadarChat";
import DialogWrapper from "../ProgramDashboard/component/DialogWrapper/DialogWrapper.view";

const customColors = {
  ACTION: "#1E4BB5",
  LEARNING: "#17BCD5",
  QUIZ: "#16C59B",
  STREAK: "#F29E2F",
  VIDEO: "#F55D5D",
  OTHER: "#9B4BF6",
};

const rewardReedemColor = {
  GIFT_REDEMPTION_EXTERNAL: "#f4a621",
  GIFT_REDEMPTION_INTERNAL: "#1f78c1",
};
function UserDashboard() {
  const {
    form,
    changeTextData,
    rewardData,
    earnedData,
    redeemedData,
    earnerTable,
    handleDetail,
    redeemedTable,
    engagementTable,
    petData,
    trendData,
    graphData,
    handleReset,
    expandedView,
    handleExpand,
    setExpandedView,
    handleProgramRedTrendExport,
    handleProgramEngTrendExport,
  } = useUserDashboard({});
  return (
    <div className={styles.dashboardContainer}>
      <TopField
        form={form}
        changeTextData={changeTextData}
        handleReset={handleReset}
      />
      <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Rewards Earned</strong> <br />{" "}
          {rewardData?.earned ?? "-"}
        </div>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Rewards Redeemed</strong> <br />{" "}
          {rewardData?.redeemed ?? "-"}
        </div>
      </div>
      <div className="formFlex">
        <div className="formGroup">
          <PetAdoptedChart
            data={petData}
            title="Pet Adopted"
            isExpand
            // isImgDownload
            onExpand={() =>
              handleExpand(
                "Trend",
                <PetAdoptedChart
                  data={petData}
                  title="Pet Adopted"
                  isExpand={false}
                  isImgDownload={false}
                />
              )
            }
          />
        </div>
      </div>
      <div className="formGroup">
        <TrendChart
          trendData={trendData}
          title="Daily Redemption Ratio Trend"
          downloadTitle="Daily Redemption Ratio Download"
          isExport
          handleExport={handleProgramRedTrendExport}
          dataSet={[
            {
              label: "Earned",
              data: trendData?.ratio || [],
              borderColor: "#E26D14",
              borderWidth: 1,
              pointBackgroundColor: "#E26D14",
              pointRadius: 2,
              fill: false,
            },
          ]}
          isImgDownload
          isExpand
          onExpand={() =>
            handleExpand(
              "Trend",
              <TrendChart
                trendData={trendData}
                title="Trend"
                dataSet={[
                  {
                    label: "Earned",
                    data: trendData?.ratio || [],
                    borderColor: "#E26D14",
                    borderWidth: 1,
                    pointBackgroundColor: "#E26D14",
                    pointRadius: 2,
                    fill: false,
                  },
                ]}
                isImgDownload={false}
                isExpand={false}
              />
            )
          }
        />
      </div>
      <div className={"formGroup"}>
        <div className={styles.radarCont}>
          <CustomRadarChart
            graphData={graphData}
            isImgDownload
            isExpand
            downloadTitle="Engagement Download"
            isExport
            handleExport={handleProgramEngTrendExport}
            title="Engagement"
            onExpand={() =>
              handleExpand(
                "Engagement",
                <CustomRadarChart
                  graphData={graphData}
                  isImgDownload={false}
                  isExpand={false}
                />
              )
            }
          />
        </div>
      </div>
      <div className={"formFlex"}>
        <div className={"formGroup"}>
          <StackedBarChart
            // className={styles.chartContainer}
            title="Reward Earned"
            data={earnedData}
            dataKey="label"
            isExpand
            isImgDownload
            downloadTitle="Reward Earned Download"
            isExport
            handleExport={handleProgramRedTrendExport}
            colors={customColors}
            // sx={{ backgroundColor: "#f5f5f5" }}
            onExpand={() =>
              handleExpand(
                "Trend",
                <StackedBarChart
                  // className={styles.chartContainer}
                  title="Reward Earned"
                  data={earnedData}
                  dataKey="label"
                  colors={customColors}
                  isImgDownload={false}
                  isExpand={false}
                />
              )
            }
          />
        </div>
      </div>

      <div className={"formFlex"}>
        <div className={"formGroup"}>
          <StackedBarChart
            // className={styles.chartContainer}
            title="Reward Redeemed"
            data={redeemedData}
            dataKey="label"
            colors={rewardReedemColor}
            isExpand
            downloadTitle="Reward Redeemed Download"
            isExport
            handleExport={handleProgramRedTrendExport}
            isImgDownload
            // sx={{ backgroundColor: "#f5f5f5" }}
            onExpand={() =>
              handleExpand(
                "Trend",
                <StackedBarChart
                  // className={styles.chartContainer}
                  title="Reward Redeemed"
                  data={redeemedData}
                  dataKey="label"
                  colors={rewardReedemColor}
                  isImgDownload={false}
                  isExpand={false}
                />
              )
            }
          />
        </div>
      </div>
      <div className={styles.chartWrap}>
        <div className={styles.formGrp}>
          <EarnerTable
            data={earnerTable || []}
            handleDetail={handleDetail}
            isEarner
          />
        </div>
        <div className={styles.formGrp}>
          <EarnerTable data={redeemedTable || []} handleDetail={handleDetail} />
        </div>
      </div>
      <div className={styles.chartWrap}>
        <EngagementTable
          data={engagementTable || []}
          isExport
          handleExport={handleProgramEngTrendExport}
        />
      </div>

      <DialogWrapper
        open={expandedView.open}
        onClose={() =>
          setExpandedView({ open: false, title: "", content: null })
        }
        title={expandedView.title}
      >
        {expandedView.content}
      </DialogWrapper>
    </div>
  );
}

export default UserDashboard;
